











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class HoverContainer extends Vue {
    @Prop({ type: String, default: '' }) label!: string
    @Prop({
      required: true,
      type: String,
      validator: function (v: string) {
        return ['top', 'bottom'].indexOf(v) !== -1
      }
    }) position!: string

    @Prop({ required: true, type: Boolean }) visible!: boolean
    @Prop({ required: true, type: Number }) x!: number
    @Prop({ required: true, type: String }) align!: string
    @Prop({ required: true, type: String }) justify!: string

    HOVER_CONTAINER_WIDTH = 180
    VERTICAL_OFFSET = -12

    get moveLeft () {
      return this.x - (this.HOVER_CONTAINER_WIDTH / 2)
    }

    get handleHover () {
      return {
        opacity: this.visible ? 1 : 0,
        'align-items': this.align === 'start' ? 'flex-start' : 'flex-end',
        'justify-content': this.justify.length > 0 ? this.justify : '',
        top: this.position === 'bottom' ? -12 + 'px' : 204 + 'px',
        bottom: this.position === 'top' ? 0 : 0,
        left: this.moveLeft + 'px'
      }
    }
}
